(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/footer-text.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/footer-text.js');

'use strict';

const FooterText = () => {
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerloginreact),
    isTestEnvironment = _ReactRedux$useSelect.isTestEnvironment;
  const TestPanel = svs.playerLoginReact.sharedComponents.TestPanel;
  return React.createElement("div", {
    className: "margin-xs-top-1 margin-sm-h-3"
  }, React.createElement("p", null, "Vid inloggning kontrolleras din identitet, att du \xE4r \xF6ver 18 \xE5r och folkbokf\xF6rd i Sverige."), isTestEnvironment && React.createElement(TestPanel, null));
};
svs.playerLoginReact.sharedComponents.FooterText = FooterText;

 })(window);